import type { PlayerType } from '@/types/dtos/player/response/player.dto';
import { nextNumberedPlayerName } from '@/helpers/next-numbered-player-name';

/** Stub section keys (no backend PlayerType yet). */
export type ConfigurationStubKind = 'speakerMonitor' | 'infoDisplay';

export type ConfigurationNameKind = PlayerType | ConfigurationStubKind;

type NameSpec = {
  /** Base label without number, e.g. "Room Display". */
  label: string;
  /** When false, return the label as-is (e.g. Stage). */
  numbered: boolean;
};

/** Standard auto-assigned labels for flow configuration pairing. */
export const CONFIGURATION_PLAYER_NAME_SPECS: Partial<Record<ConfigurationNameKind, NameSpec>> = {
  stagePlayer: { label: 'Stage', numbered: false },
  screenPublisher: { label: 'Media Laptop', numbered: true },
  roomPlayer: { label: 'Room Display', numbered: true },
  onlinePlayer: { label: 'Broadcast', numbered: true },
  speakerMonitor: { label: 'Speaker Monitor', numbered: true },
  confidencePlayer: { label: 'Speaker Monitor', numbered: true },
  infoDisplay: { label: 'Info Display', numbered: true },
};

export function resolveConfigurationPlayerName(
  kind: ConfigurationNameKind,
  existingNames: Array<string | undefined | null>,
): string {
  const spec = CONFIGURATION_PLAYER_NAME_SPECS[kind];
  if (!spec) {
    return nextNumberedPlayerName(kind, existingNames);
  }
  if (!spec.numbered) {
    return spec.label;
  }
  return nextNumberedPlayerName(spec.label, existingNames);
}
